import { createSelector } from 'reselect';
import HandoverAnalysisAtDestinationColumns from '../../containers/HandoverAnalysisAtDestinationColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.HANDOVER_ANALYSIS_AT_DESTINATION.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.HANDOVER_ANALYSIS_AT_DESTINATION.isLoading;

export const getData = ReportDefinitions.HANDOVER_ANALYSIS_AT_DESTINATION.getDataFunction();

export const getColumns = createSelector(getData, HandoverAnalysisAtDestinationColumns);
